import axios from "axios";

const internals = {
  vimeoUrl: "https://vimeo.com/api/oembed.json?url=",
  youtubeUrl: "https://www.youtube.com/oembed?url=",
  removeDimensions: (html) => {
    return html.replace(/width="\d+"/g, "").replace(/height="\d+"/g, "");
  },
};

const oembedParser = async (url) => {
  try {
    let data = null;
    if (url.includes("youtube")) {
      const response = await axios.get(`${internals.youtubeUrl}${url}`);
      data = response.data;
    } else if (url.includes("vimeo")) {
      const response = await axios.get(`${internals.vimeoUrl}${url}`);
      data = response.data;
    }

    data.html = internals.removeDimensions(data.html);

    return data;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export default oembedParser;
